<template>
  <section class="rich-text">
    <div class="rich-text-main" v-html="richText.content"></div>
    <div class="rich-text-dialog" v-if="isDialogShow">
      <div class="rich-text-dialog-img">
        <img src="../assets/images/richtext-show.png" alt="">
        <div class="rich-text-dialog-img-context">
        </div>
        <div class="rich-text-dialog-img-btn" @click="tuneUpWX()">立即调起微信</div>
      </div>
    </div>
    <div class="rich-text-btn" id="clip-click" @click="showDialog" v-if="!isWx" data-clipboard-action="copy" data-clipboard-text="微课">
      立 即 免 费 领 取
    </div>
    <!-- <div class="rich-text-btn"  @click="showDialog"></div> -->
  </section>
</template>

<script>
  import api from '@edu-fe/api'
  import barBus from '../bar/bus'
  import clipboard from 'clipboard'
  import { isxxx } from '@mixins'

  export default {
    name: 'RichText',
    mixins: [isxxx],
    data() {
      return {
          richText:'',
          isDialogShow: false,
          textcontent: "微课",
      }
    },
    mounted() {
      this.init()
      barBus.$emit('hideBar')
    },
    computed : {
      text() {
        return this.$refs.text
      }
    },
    methods: {
      async init(){
          this.richText = await api.create(`/web/content?id=${this.$route.query.id}`)().then(res => {
              if(res.code === 1){
                  return res.data
              }else{
                  alert(res.code)
              }
          })
          console.log(this.richText)
      },
      showDialog() {
        if (clipboard.isSupported()) {
          const clip = new clipboard('#clip-click');
          clip.on('success', e => {
              this.tuneUpWX()
              clip.destroy();
          });
          clip.on('error', e => {
              alert('复制失败')
              this.tuneUpWX()
              clip.destroy();
          });
        } else {
          this.tuneUpWX()
        }
      },
      tuneUpWX () {
        window.location.href = 'weixin://'
      } 
    }
  }
</script>

<style lang="scss">
  @charset 'utf-8';
  @import "../style/main";
  .rich-text{
    position: relative;
    img {
      width: 100%;
    }
    &-dialog {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 999;
      background: rgba($color: #000000, $alpha: .4);
      &-img{
        box-sizing: border-box;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        padding: rem(91) rem(20) rem(60) rem(20);
        width: rem(690);
        height: rem(877);
        background: url('../assets/images/richtext-img.png');
        background-size: contain;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        &-context {
          line-height: 1.5;
          > h3 {
            color: #FF851E;
            font-size: rem(30);
            margin-bottom: rem(20);
          }
          ul {
            position: relative;
            font-size: rem(28);
            color: #666;
            > li{
              width: rem(410);
              margin: auto;
              margin-bottom: rem(26);
              span {
                display: inline-block;
                margin-right: rem(16);
                font-size: rem(24);
                width: rem(30);
                height: rem(33);
                background-color: #ffb88f;
                border-radius: 100%;
                text-align: center;
                color: #fff;
              }
            }
          }
        }
        &-btn {
          width: rem(500);
          height: rem(90);
          line-height: rem(90);
          font-size: rem(36);
          // position: absolute;
          // bottom: 7%;
          background-color: #ff8325;
          text-align: center;
          color: #fff;
        }
      }
    }
    &-btn {
      position: fixed;
      width: 100%;
      bottom: 0;
      height: rem(100);
      line-height: rem(100);
      text-align: center;
      font-size: rem(36);      
      color: #fff;
      background-color: #ff8325;
    }
    textarea {
      position: absolute;
      top: 0%;
      left: 0;
      z-index: -100;
      opacity: 0;
    }
  }
  
</style>
